module.exports = __webpack_public_path__ + "static/media/calendar.3d00667d.svg";